const record = {
  state: () => ({
    // Record Data
    faceVideoData: {
      position: { top: 'unset', left: 0, right: 'unset', bottom: 0 },
      width: 0,
      height: 0,
      margin: { top: 0, left: 'calc(1.2vw)', right: 0, bottom: 'calc(1.2vw)' },
      separatedAlign: 'left',
      shape: 'round',
      size: 'small',
      layoutType: 'corner',
      bgColor: '#FF464F',
      gradient: {
        start: '#0062FF',
        end: '#FF575F',
      },
      isUseGradient: false,
      toggle_layout: 0,
      toggle_separated: 0,
      toggle_shape: 0,
      toggle_size: 0,
      radios1: 'radio-3',
    },
    // Layout 이 변경된걸 감지할 때 사용
    isLayoutChanged: null,
    showPreferenceDialog: null,
  }),
  mutations: {
    setFaceVideoData(state, faceVideoData) {
      state.faceVideoData = faceVideoData
    },
    setIsLayoutChanged(state, isLayoutChanged) {
      state.isLayoutChanged = isLayoutChanged
    },
    setShowPreferenceDialog(state, showPreferenceDialog) {
      state.showPreferenceDialog = showPreferenceDialog
    },
  },
  actions: {
    setFaceVideoData({ commit }, faceVideoData) {
      commit('setFaceVideoData', faceVideoData)
    },
    setIsLayoutChanged({ commit }, isLayoutChanged) {
      commit('setIsLayoutChanged', isLayoutChanged)
    },
    setShowPreferenceDialog({ commit }, showPreferenceDialog) {
      commit('setShowPreferenceDialog', showPreferenceDialog)
    },
  },
  getters: {
    faceVideoData(state) {
      return state.faceVideoData
    },
    isLayoutChanged(state) {
      return state.isLayoutChanged
    },
    showPreferenceDialog(state) {
      return state.showPreferenceDialog
    },
  },
}

export default record
